import { HttpClient } from '@angular/common/http';
import { Component, ViewContainerRef } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';

declare var gtag;


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {

  loading = true;
  googleAnalytics: string;

  constructor(translate: TranslateService, router: Router,
    public vcRef: ViewContainerRef,
    public http: HttpClient) {


    // Inicialitzem les dades per business

    const navEndEvents = router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    );

    // Google Tag Manager
    navEndEvents.subscribe((event: NavigationEnd) => {
      // gtag('config', 'G-4PY4RPQXB3', {
      //   'page_path': event.urlAfterRedirects
      // });
      const url = event.urlAfterRedirects;

    });


    //Google Tag Manager
    navEndEvents.subscribe((event: NavigationEnd) => {
      if (event.urlAfterRedirects == '/' || event.urlAfterRedirects.includes('validate')) {
        gtag('config', 'G-0K29ZZSDRB', {
          'page_path': event.urlAfterRedirects
        });

        gtag('event', 'account_created');


        // const gtmTag = {
        //   event: 'page_path',
        //   pageName: event.urlAfterRedirects
        // };

        // this.gtmService.pushTag(gtmTag);

      }
    });

    translate.addLangs(['en', 'es', 'fr', 'ca', 'it', 'ja', 'pt', 'pl', 'ko', 'de', 'zhchs', 'zhcht', 'hi', 'id', 'bn', 'ur', 'hy', 'tr', 'nl', 'cs', 'bg', 'da', 'fa', 'hr', 'km', 'uk']);
    translate.setDefaultLang('en');

  }


}
